export default "__VITE_ASSET__DiZSd$vp__"